import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import Button from '../components/Button'
import VNConcessionsNavBar from '../components/VNConcessionsNavBar'
import { setRoute } from '../VNRoutes/ActionCreators'
import { useDispatch, useSelector } from 'react-redux'
import VNBlueSwitch from '../components/VNBlueSwitch'
import styles from './RevenueCenterSetup.module.scss'
import useGetIsMobileScreen from '../hooks/useGetIsMobileScreen'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setBarcodeScanningSettings } from '../actions/config'
import { APPLICATION_STRINGS } from '../strings'
import Record from '../components/Record'
import { ReactComponent as SelectedRadioButton } from '../assets/icons/selected-radio-button-icon.svg'
import { ReactComponent as UnselectedRadioButton } from '../assets/icons/unselected-radio-button-icon.svg'
import { SHIFT4_BLUE } from '../styles/constants'
import { getAllAttendants, getFetchAttendantsStatus } from '../selectors/attendant'
import { Divider } from '@material-ui/core'
import { getBarcodeScanningSettings } from '../selectors/config'

const BarcodeScanningSettingsConfig = ({ className }) => {
  const classNames = cn(styles.revenueCenterSetup, className)

  const history = useHistory()
  const dispatch = useDispatch()
  const isMobileViewPort = useGetIsMobileScreen()

  const fetchAttendantsStatus = useSelector((state) => getFetchAttendantsStatus(state))
  const attendants = useSelector((state) => getAllAttendants(state))
  const barcodeScanningSettings = useSelector(getBarcodeScanningSettings)

  const [barcodeScanningEnabled, setBarcodeScanningEnabled] = useState(barcodeScanningSettings?.barcodeScanningEnabled || false)
  const [displayScannableItems, setDisplayScannableItem] = useState(barcodeScanningSettings?.displayScannableItems || false)

  const storeSelection = () => {
    // it could be the case that the user forgot display scannable items as true, this if statement handles that
    if (!barcodeScanningEnabled) {
      dispatch(setBarcodeScanningSettings({ barcodeScanningEnabled: false, displayScannableItems: false }))
      return
    }

    dispatch(setBarcodeScanningSettings({ barcodeScanningEnabled, displayScannableItems }))
  }

  useEffect(() => {
    if (isMobileViewPort) {
      setBarcodeScanningEnabled(false)
      setDisplayScannableItem(false)
    }
  }, [isMobileViewPort])

  const goBack = () => {
    storeSelection()
    if (history?.location?.state?.fromRevenueCenterSetup) {
      history.replace('/revenue-center-setup', { fromBarcodeScanningConfig: true })
      return
    }
    dispatch(setRoute('/printer-settings-config'))
  }

  const handleDone = () => {
    storeSelection()
    if (!isEmpty(attendants)) {
      history.replace({
        pathname: '/user-login',
        state: {
          attendantsAlreadyFetched: fetchAttendantsStatus === 'succeeded',
        },
      })
      return
    }

    history.replace('/concession-order')
  }

  const RenderMobileError = () => {
    if (isMobileViewPort) {
      return <div className={styles.noTipsMobile}>{APPLICATION_STRINGS.BARCODE_SCANNING_DISABLED_MOBILE}</div>
    }
    return null
  }

  const RenderDisplayScannableItems = ({ disabled, name, onClick, isChecked }) => {
    return (
      <div className={styles.record}>
        <div className={styles.menuDetails} style={{ width: '100%', justifyContent: 'space-between' }}>
          <div className={styles.svgIconContainer} style={{ width: '100%', justifyContent: 'left' }}>
            {name}
          </div>
          <div className={styles.svgIconContainer}>
            <VNBlueSwitch disabled={disabled} onClick={onClick} checked={isChecked} />
          </div>
        </div>
      </div>
    )
  }

  const getIcon = (isChecked) => {
    const icon = isChecked ? <SelectedRadioButton /> : <UnselectedRadioButton />

    return <div className={styles.svg}>{icon}</div>
  }

  const renderRecord = (name, onClick, isChecked, key, disabled) => {
    const icon = getIcon(isChecked)
    const style = { backgroundColor: isChecked ? SHIFT4_BLUE : undefined }

    return <Record disabled={disabled} key={key} icon={icon} name={name} style={style} styles={styles} onClick={onClick} />
  }

  const renderDisplayScannableItemsRecord = () => {
    if (!barcodeScanningEnabled || isMobileViewPort) {
      return null
    }

    return (
      <div>
        <Divider className={styles.divider} />
        <RenderDisplayScannableItems
          name={APPLICATION_STRINGS.DISPLAY_SCANNABLE_ITEMS}
          onClick={() => setDisplayScannableItem(!displayScannableItems)}
          isChecked={displayScannableItems}
        />
      </div>
    )
  }
  return (
    <div>
      <div className={classNames}>
        <VNConcessionsNavBar
          textDisplay={isMobileViewPort && APPLICATION_STRINGS.BARCODE_SCANNING_SETTINGS}
          useSmallTitleFont={true}
          useHamburgerIcon={true}
        />
        {!isMobileViewPort && <div className={styles.header}>{APPLICATION_STRINGS.BARCODE_SCANNING_SETTINGS}</div>}
        <div className={styles.container}>
          <div className={styles.container}>
            {RenderMobileError()}
            <div className={styles.standMenus}>
              {renderRecord(
                APPLICATION_STRINGS.DISABLE_BARCODE_PRODUCT_SCANNING,
                () => {
                  if (isMobileViewPort) return
                  setBarcodeScanningEnabled(false)
                },
                !barcodeScanningEnabled,
                'disableBarcodeScanning',
                isMobileViewPort,
              )}
              {renderRecord(
                APPLICATION_STRINGS.ENABLE_BARCODE_PRODUCT_SCANNING,
                () => {
                  if (isMobileViewPort) return
                  setBarcodeScanningEnabled(true)
                },
                barcodeScanningEnabled,
                'enableBarcodeScanning',
                isMobileViewPort,
              )}

              {renderDisplayScannableItemsRecord()}
            </div>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button useMui className={styles.backButton} onClick={goBack}>
            Back
          </Button>
          <Button useMui className={styles.doneButton} onClick={() => handleDone()}>
            Done
          </Button>
        </div>
      </div>
    </div>
  )
}

export default BarcodeScanningSettingsConfig
